import type { DefaultValues } from 'react-hook-form';
import { queryString } from '@olivierpascal/helpers';
import { Stack } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import type { ILogInFormValues } from '~/components/forms/LogInForm';
import { Link } from '~/components/atoms/Link';
import { LogInForm } from '~/components/forms/LogInForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type ILogInPageProps = {
  defaultValues?: DefaultValues<ILogInFormValues>;
  nextUrl?: string;
};

export const LogInPage: React.FC<ILogInPageProps> = (props) => {
  const { defaultValues, nextUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('LogInPage.seo.title')}</title>
      </Helmet>

      <Heading title={t('LogInPage.title')} />

      <Stack gap={4}>
        <LogInForm
          defaultValues={defaultValues}
          onSuccess={(authorization) => {
            const next = nextUrl?.startsWith('/') ? nextUrl : '/';
            navigate(next, {
              appRegion: authorization.region,
            });
          }}
        />
        <p>
          {t('LogInPage.new-to-crowdaa')}{' '}
          <Link
            to={`^/signup?${queryString.build({ nextUrl, appRegion: defaultValues?.appRegion })}`}
          >
            {t('LogInPage.sign-up')}
          </Link>
        </p>
      </Stack>
    </>
  );
};
